/**
 * Generate a RFC 4122-compliant UUID v4.
 *
 * Uses `crypto.randomUUID` when available (all modern browsers and Node ≥ 15).
 * Falls back to a Math.random-based implementation for older environments.
 */
export function generateGuid(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

/**
 * Strips all whitespace characters from a string.
 *
 * Used to normalize payment/ACH/card field values before submission.
 */
export function cleanValue(value: string): string {
  return value.replace(/\s/g, '');
}

/**
 * Removes leading and trailing whitespace from a string.
 *
 * Used to normalize address and text input field values before submission.
 */
export function trimValue(value: string): string {
  return value.trim();
}

/**
 * Extracts the origin from a URL string.
 *
 * Used to derive the postMessage target origin from a configured fragment URL.
 */
export function normalizeOrigin(url: string): string {
  return new URL(url).origin;
}
